<template>
  <div class="mine">
    <div class="page-header">
      <span>Mine</span>
      <img
        v-if="!isDeleteStatus"
        src="@/assets/images/icon/trash-black.png"
        alt=""
        @click="isDeleteStatus = true"
      >
      <div v-else class="cannel-btn" @click="cannel">Cannel</div>
    </div>
    <div class="tabs">
      <div :class="['tab', {'active': activeIdx === 0}]" @click="changeTab(0)">Favorite</div>
      <div :class="['tab', {'active': activeIdx === 1}]" @click="changeTab(1)">History</div>
    </div>
    <div class="novel-list">
      <!-- 收藏列表 -->
      <template v-if="activeIdx === 0">
        <div
          v-for="(item, index) in shelfBooks"
          :key="item.id"
          class="novel-item"
          @click="handleClick(item.novel, index)"
        >
          <div class="image-wrap">
            <img :src="item.novel.cover" alt="">
            <i v-if="isDeleteStatus" :class="['check-icon', item.isCheck ? 'checked': '']"></i>

          </div>
          <div class="novel-info">
            <p class="novel-title">{{ item.novel.title }}</p>
            <p v-if="item.novel.summary" class="novel-intro">{{ item.novel.summary }}</p>
          </div>
        </div>
      </template>
      <!-- 历史列表 -->
      <template v-if="activeIdx === 1">
        <div
          v-for="(item, index) in historyRecords"
          :key="item.id"
          class="novel-item"
          @click="handleClick(item, index)"
        >
          <div class="image-wrap">
            <img :src="item.cover" alt="">
            <i v-if="isDeleteStatus" :class="['check-icon', item.isCheck ? 'checked': '']"></i>

          </div>
          <div class="novel-info">
            <p class="novel-title">{{ item.title }}</p>
            <p v-if="item.summary" class="novel-intro">{{ item.summary }}</p>
          </div>
        </div>
      </template>
    </div>
    <!-- 删除 -->
    <div
      v-if="isDeleteStatus"
      class="check-all-container"
    >
      <div :class="['check-all-wrap', checkedList.length ? 'active' : '']">
        <div @click="handleCheckAll" class="left">
          <i :class="['icon', isCheckAll ? 'checked' : '']"></i>
          <span>All</span>
        </div>
        <div @click="handleRemove" class="right">
          <i class="icon"></i>
          <span>Remove（{{checkedList.length}}）</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getShelfBooks, removeShelfBooks } from '@/api';
import { getItem, delVisitRecords } from '@/utils/index';

const HISTORY = 'comics_v1_visit_records';

export default {
  data() {
    return {
      shelfBooks: [],
      isDeleteStatus: false,
      activeIdx: 0,
      historyRecords: [],
    };
  },
  computed: {
    checkedList() {
      const result = [];
      const list = this.activeIdx === 0 ? this.shelfBooks : this.historyRecords;
      list.forEach((item) => {
        if (item.isCheck) {
          result.push(item.id);
        }
      });
      return result;
    },
    isCheckAll() {
      return this.activeIdx === 0 ? (this.checkedList.length === this.shelfBooks.length) : (this.checkedList.length === this.historyRecords.length);
    },
  },
  created() {
    this.getShelfBooks();
  },
  methods: {
    async getShelfBooks() {
      const res = await getShelfBooks();
      if (res.code !== 0) return;
      this.shelfBooks = (res.data || []).map((item) => {
        item.isCheck = false;
        return item;
      });
    },
    handleClick(novel, index) {
      if (!this.isDeleteStatus) { // go detail
        this.$router.push(`/novel/${novel.id}/chapter/${novel.first_chapter_id}`);
      } else { // change status
        const res = this.activeIdx === 0 ? this.shelfBooks : this.historyRecords;
        const book = res[index];
        book.isCheck = !book.isCheck;
      }
    },
    cannel() {
      this.isDeleteStatus = false;
      const list = this.activeIdx === 0 ? this.shelfBooks : this.historyRecords;
      list.forEach((item) => {
        item.isCheck = false;
      });
    },
    handleCheckAll() {
      const {
        isCheckAll, activeIdx, shelfBooks, historyRecords,
      } = this;
      const list = activeIdx === 0 ? shelfBooks : historyRecords;
      console.log(list);
      list.forEach((im) => {
        im.isCheck = !isCheckAll;
      });
    },
    async handleRemove() {
      const confirm = await this.$confirm('Removing', 'Are you sure you want to remove these comics?');
      if (confirm !== 'confirm') return;
      const ids = this.checkedList;
      if (this.activeIdx === 0) {
        const res = await removeShelfBooks(ids);
        if (res.code !== 0) {
          this.$toast.error('Delete Fail');
          return;
        }
        this.cannel();
        this.getShelfBooks();
      } else {
        delVisitRecords(ids);
        this.cannel();
        this.getHistoryRecords();
      }
    },
    changeTab(idx) {
      const { activeIdx } = this;
      if (activeIdx === idx) return;
      if (this.isDeleteStatus) {
        this.$toast.error('please exit edit mode');
        return;
      }
      this.activeIdx = idx;
      if (idx === 0) {
        this.getShelfBooks();
      } else if (idx === 1) {
        this.getHistoryRecords();
      }
    },
    getHistoryRecords() {
      const res = getItem(HISTORY);
      this.historyRecords = (res || []).map((item) => {
        item.isCheck = false;
        return item;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mine {
  padding-bottom: 20px;
  position: relative;
  .page-header {
    position: sticky;
    position: -webkit-sticky;
    width: 100vw;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: @black;
    background-color: #fff;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;

    img {
      width: 24px;
      height: 24px;
    }
    .cannel-btn {
      width: 84px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 16px;
      background: rgba(13, 13, 13, 0.06);
      color: @black;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .tabs {
    height: 56px;
    display: flex;
    // justify-content: center;
    background-color: #fff;
    align-items: center;
    position: sticky;
    position: -webkit-sticky;
    width: 100vw;
    top: 44px;
    z-index: 10;

    .tab {
      width: 33%;
      height: 44px;
      padding-bottom: 8px;
      line-height: 36px;
      position: relative;
      color:  @gray;
      font-size: @fontMedium;
      text-align: center;
      &.active {
        color: @theme;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 48px;
          height: 4px;
          border-radius: 2px;
          background-color: @theme;
        }
      }

    }
  }
  .novel-list {
    padding-top: 9px;
    display: flex;
    flex-wrap: wrap;
    padding-left: 16px;
    // justify-content: space-around;

    .novel-item {
      width: 156px;
      margin-bottom: 16px;
      margin-right: 16px;
      .image-wrap {
        height: 200px;
        border-radius: 12px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 12px;
          vertical-align: middle;
        }
        .check-icon {
          position: absolute;
          right: 6px;
          bottom: 6px;
          .iconMixin({
            background-image: url('~@/assets/images/icon/uncheck.png');
          });
          &.checked {
            background-image: url('~@/assets/images/icon/checked.png');
          }
        }

      }
      .novel-info {
        padding-top: 8px;
        min-height: 48px;
        background-color: #fff;
        .novel-title {
          line-height: 24px;
          font-size: @fontLarge;
          color: @black;
          .overflow-ellipsis(1);
        }
        .novel-intro {
          line-height: 16px;
          font-size: @fontSmall;
          color: @gray;
          .overflow-ellipsis(1);
        }
      }
    }
  }

  .check-all-container {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    width: 100vw;
    padding-top: 16px;
    background-color: #fff;
    .check-all-wrap {
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      .border-1px('top', rgb(30, 30, 30));
      &.active {
        .right {
          color: @black;
          .icon {
            background-image: url('~@/assets/images/icon/trash-black.png');
          }
        }

      }
      .left {
        display: flex;
        line-height: 24px;
        color: @black;
        font-size: @fontMedium;
        .icon {
          .iconMixin({
            margin-right: 8px;
            background-image: url('~@/assets/images/icon/uncheck.png');
          });
          &.checked {
            background-image: url('~@/assets/images/icon/checked.png');
          }
        }

      }
      .right {
        width: 243px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 22px;
        background-color: rgba(13, 13, 13, 0.06);

        color: @gray;
        font-size: @fontMedium;
        .icon {
          .iconMixin({
            margin-right: 8px;
            background-image: url('~@/assets/images/icon/trash.png');
          })
        }
      }
    }
  }
}

</style>
